import request from '@/utils/request'

// 查询用户活动参与列表
export function listUserActivity(query) {
    return request({
        url: '/h5/userActivity/list',
        method: 'get',
        params: query
    })
}

// 查询用户活动参与详细
export function getUserActivity(id) {
    return request({
        url: '/h5/userActivity/' + id,
        method: 'get'
    })
}


// 获取用户参加的即将开始的活动
export function getToDoList(userId) {
    return request({
        url: '/h5/userActivity/todo/' + userId,
        method: 'get'
    })
}

// 查询用户活动参与详细
export function getUserActivityByUserIdAndActivityId(activityId) {
    return request({
        url: '/h5/userActivity/getByActivityId/' + activityId,
        method: 'get'
    })
}

// 新增用户活动参与
export function addUserActivity(data) {
    return request({
        url: '/h5/userActivity',
        method: 'post',
        data: data
    })
}

// 修改用户活动参与
export function updateUserActivity(data) {
    return request({
        url: '/h5/userActivity',
        method: 'put',
        data: data
    })
}

// 删除用户活动参与
export function delUserActivity(id) {
    return request({
        url: '/h5/userActivity/' + id,
        method: 'delete'
    })
}


// 用户签到打卡
export function userActivitySign(data) {
    return request({
        url: '/h5/userActivity/sign',
        method: 'post',
        data: data
    })
}


// 用户签退打卡
export function userActivitySignOut(data) {
    return request({
        url: '/h5/userActivity/signOut',
        method: 'post',
        data: data
    })
}


// 获取团队当月排行榜
export function userActivityTimeDeptMonth() {
    return request({
        url: '/h5/userActivity/userActivityTimeDeptMonth',
        method: 'get',
    })
}

// 获取团队当季度排行榜
export function userActivityTimeDeptQuarter() {
    return request({
        url: '/h5/userActivity/userActivityTimeDeptQuarter',
        method: 'get',
    })
}


// 获取团队当年排行榜
export function userActivityTimeDeptYear() {
    return request({
        url: '/h5/userActivity/userActivityTimeDeptYear',
        method: 'get',
    })
}


// 根据团队id获取团队当月详情
export function userActivityTimeDeptDetailsMonthById(deptId) {
    return request({
        url: '/h5/userActivity/userActivityTimeDeptDetailsMonthById?deptId=' + deptId,
        method: 'get',
    })
}

// 根据团队id获取团队当季度总详情
export function userActivityTimeDeptDetailsQuarterById(deptId) {
    return request({
        url: '/h5/userActivity/userActivityTimeDeptDetailsQuarterById?deptId=' + deptId,
        method: 'get',
    })
}


// 根据团队id获取团队当年总详情
export function userActivityTimeDeptDetailsYearById(deptId) {
    return request({
        url: '/h5/userActivity/userActivityTimeDeptDetailsYearById?deptId=' + deptId,
        method: 'get',
    })
}


// 获取个人当月排行榜
export function userActivityTimeUserMonth() {
    return request({
        url: '/h5/userActivity/userActivityTimeUserMonth',
        method: 'get',
    })
}

// 获取个人当季度排行榜
export function userActivityTimeUserQuarter() {
    return request({
        url: '/h5/userActivity/userActivityTimeUserQuarter',
        method: 'get',
    })
}


// 获取个人当年排行榜
export function userActivityTimeUserYear() {
    return request({
        url: '/h5/userActivity/userActivityTimeUserYear',
        method: 'get',
    })
}


// 根据个人id获取个人当月详情
export function userActivityTimeUserDetailsMonthById(userId) {
    return request({
        url: '/h5/userActivity/userActivityTimeUserDetailsMonthById?userId=' + userId,
        method: 'get',
    })
}

// 根据个人id获取个人当季度总详情
export function userActivityTimeUserDetailsQuarterById(userId) {
    return request({
        url: '/h5/userActivity/userActivityTimeUserDetailsQuarterById?userId=' + userId,
        method: 'get',
    })
}


// 根据个人id获取个人当年总详情
export function userActivityTimeUserDetailsYearById(userId) {
    return request({
        url: '/h5/userActivity/userActivityTimeUserDetailsYearById?userId=' + userId,
        method: 'get',
    })
}
